<div style="font-size: 16px !important">
    @if(entry === 'providerEnrollment' && isProcessed && !isViewTimeOff){
    <div style="width: 50%; display: flex; font-size: 16px; margin:24px;">
        <p style="width: 100%;">
            Select Consumer:
        </p>
        <nz-select [(ngModel)]="consumer" class="ppl-select" id="consumer" nzPlaceHolder="Select Consumer"
            (ngModelChange)="consumerValueChange($event)" nzShowSearch nzAllowClear>
            @for(opt of consumers; track $index){
            <nz-option [nzLabel]="opt.consumerFullName" [nzValue]="opt"></nz-option>
            }
        </nz-select>
    </div>
    }

    @if(showTimesheets){

    @if(entry === 'providerEnrollment'){
    <nz-divider></nz-divider>
    <div style="margin:24px;">
        <p>
            <strong>Consumer Name: </strong> {{consumerName}}
        </p>
        <p>
            <strong>Consumer PPL ID:</strong> {{consumerPPLId}}
        </p>
    </div>

    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="TSdata"
    (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)"
    [disableSelection]="true" [cols]="cols" [gridTitle]="false" [timesheetFor]="'provider'"
        [pagination]="false" [showLineItem]="true" [loadPage]="true">
    </ppl-list-table>

    }
    }

    @if(entry === 'participantEnrollment'){
    <nz-divider></nz-divider>
    <div style="margin:24px;">
        <p>
            <strong>Personal Assistant Name: </strong> {{providerName}}
        </p>
        <p>
            <strong>Personal Assistant PPL ID:</strong> {{providerPplId}}
        </p>
    </div>

    @if(!isProcessed){
    <div class="custom-row">
        <div class="mr-2">
            <!-- *authorize="[pageId, tabId, 'approvePayroll', 'button']" -->
            <ppl-button label="Approve" (click)="approvePayroll()" [customClass]="'ghost-button'"
                [iconPosition]="'left'"></ppl-button>
        </div>

        <div class="mr-2">
            <ppl-button label="Deny" (click)="denyPayroll()" [customClass]="'ghost-button'"
                [iconPosition]="'left'"></ppl-button>
        </div>
    </div>
    }
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="consumerLineData"
        (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)" (selectionChanged)="selectionChanged($event)"
        [disableSelection]="isProcessed" [cols]="consumer_cols" [gridTitle]="false" [pagination]="false"
        [showLineItem]="true" [additionalCols]="additionalCols" [timesheetFor]="'consumer'" (showAuthDetails)="showAuthDetails($event)" [loadPage]="true">
    </ppl-list-table>

    }

    @if(entry === 'providerEnrollment' && isViewTimeOff){
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="timeoffData"
        (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)" [disableSelection]="true" [cols]="timeoff_cols" [gridTitle]="false"
        [pagination]="false" [showLineItem]="true" [loadPage]="true">
    </ppl-list-table>
    }
</div>

<div class="filter-panel">
    <ng-template #denyDialog let-cancel="cancel">
        <p>Reason: </p>
        <nz-select nzPlaceHolder="Select Reason" [(ngModel)]="selectedReason" style="width:100%; margin-bottom: 16px"
            nzShowArrow>
            @for(item of listOfOption; track $index ){
            <nz-option [nzLabel]="item" [nzValue]="item"></nz-option>
            }
        </nz-select>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
       <ppl-authorization-details [pageSource]="'timesheet'"></ppl-authorization-details>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDataDialog let-cancel="cancel">
        <ppl-timesheet-staff-authdata [authData]="authData" (showAuthDetails)="showAuthDetails($event)"></ppl-timesheet-staff-authdata>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData"
            (onSaveComplete)="onSaveAdjustment($event)" [disabled]="true"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
    </ng-template>
</div>